<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <b-card-body>
            <b-row>
              <b-col md="6">
                <b-form-group label="ID">
                  <b-form-input v-model="apiKey.id" readonly></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Description">
                  <b-form-input v-model="apiKey.description" readonly></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group label="Created At">
                  <b-form-input v-model="apiKey.createdAt" readonly></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Updated At">
                  <b-form-input v-model="apiKey.updatedAt" readonly></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="API Secret (read-only)">
                  <b-input-group>
                    <b-form-input v-model="apiKey.secret" readonly :type="showSecret ? 'text' : 'password'"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="outline-secondary" @click="toggleSecretVisibility">
                        {{ showSecret ? 'Hide' : 'Show' }}
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-muted d-block mt-2">
                    <strong>Note:</strong> The secret is displayed once at creation. Save it in a secure location.
                  </small>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getApiKey } from "@/services/ApiKeyService";
import { BButton, BCard, BCardBody, BCol, BForm, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BRow } from 'bootstrap-vue';

export default {
  name: "ApiKeyDetail",
  components: {
    BButton,
    BCard,
    BCardBody,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BRow
  },
  data() {
    return {
      apiKey: {
        id: '',
        secret: '',
        description: '',
        createdAt: '',
        updatedAt: ''
      },
      showSecret: false
    }
  },
  async mounted() {
    const data = await getApiKey(this.$route.params.id);
    this.apiKey = data;
  },
  methods: {
    toggleSecretVisibility() {
      this.showSecret = !this.showSecret;
    }
  }
};
</script>
